<template>
  <div style>
    <el-card class="box-card">
      <div>
        <div class="item">设备编号：{{device.id}}</div>
        <div class="item">设备类型：{{device.typeName}}</div>
        <div class="item">剩余次数：{{device.useNumber}} 次</div>
        <div class="item">门店名称：{{device.shopName}}</div>
        <div class="item">设备状态：{{device.status==0?"离线":device.status==1?"在线":device.status}}</div>
        <div v-if="startSuccess" class="success">
          <el-alert title="启动成功" description="设备已成功启动！" type="success" show-icon :closable="false"></el-alert>
        </div>
        <div v-else class="item center">
          <el-button type="primary" @click="start">启动设备</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import axios from "axios";
const instance = axios.create({
  baseURL: "",
  timeout: 0,
  headers: { "token-staff": localStorage.getItem("token-staff") }
});
let loading = null;
export default {
  data() {
    return {
      device: {
        id: null,
        typeName: null,
        useNumber: null,
        shopName: null,
        status: null
      },
      startSuccess: false
    };
  },
  created: function() {
    let that = this;
    let id = that.$route.query.id;
    if (!id) {
      that.$message({
        message: "设备id不存在请重新扫码！",
        type: "warning",
        duration: 2000,
        onClose: function() {}
      });
    } else {
      this.api.staff.getDevice({ id: id }).then(response => {
        if (!response.data.errorCode) {
          Object.assign(that.device, response.data.data);
        }
      });
    }
  },
  methods: {
    start: function() {
      let that = this;
      let id = that.$route.query.id;
      if (!id) {
        that.$message({
          message: "设备id不存在请重新扫码！",
          type: "warning",
          duration: 2000,
          onClose: function() {}
        });
      } else {
        this.api.staff
          .startDevice({ id: that.$route.query.id })
          .then(response => {
            if (!response.data.errorCode) {
              loading = this.$loading({
                lock: true,
                text: "正在启动设备...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
              });
              setTimeout(() => {
                that.queryStatus(response.data.data.id);
              }, 5000);
            }
          });
      }
    },
    queryStatus(id) {
      let that = this;
      instance.get(`/staff/device/order/${id}`).then(response => {
        if (!response.data.errorCode) {
          console.log(response);
          if (response.data.data.status == 1) {
            setTimeout(() => {
              that.queryStatus(response.data.data.id);
            }, 5000);
          } else if (response.data.data.status == 2) {
            loading.close();
            that.startSuccess = true;
          } else if (response.data.data.status == 3) {
            loading.close();
            this.$message.error("启动失败！");
          }
        }
      });
    }
  }
};
</script>
<style scoped>
.item {
  padding: 15px;
  font-size: 14px;
}
.center {
  text-align: center;
  padding: 30px;
}
</style>


// WEBPACK FOOTER //
// index.vue?1884bce3